// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c7cb846","667":"90506fdf","885":"b14f1ee8","977":"fc56c880"}[chunkId] + ".chunk.js";
};